import { get, put,Delete,post } from '../axios'

// banner-列表
export const remindList = params => get(`/web/message/remind/list`,params);


